import { Card, Typography, Box, LinearProgress } from '@mui/material';
import { OrganCardStyles } from '../styles/OrganCardStyles';

interface OrganCardProps {
  tag: string;
  progress: number;
  handleOnClick: (tag: string) => void;
}

export const TAGS = [
  'Heart',
  'Lung',
  'Stomach',
  'Spleen',
  'Liver',
  'Gallbladder',
  'Large Intestine',
  'Small Intestine',
  'Triple Burner',
  'Kidney',
  'Bladder',
  'Pericardium',
];

export const TAG_TO_IMAGE: Record<string, string> = {
  Heart:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/heart_l9qhm8.png',
  Lung: 'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191688/lung_jfcbgb.png',
  Stomach:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191689/stomach_y9jzlk.png',
  Spleen:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191689/spleen_kkr9ut.png',
  Liver:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/liver_nll605.png',
  Gallbladder:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/gallbladder_h9n6x1.png',
  'Large Intestine':
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/large_intestine_ksi8wb.png',
  'Small Intestine':
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191689/small_intestine_jmeeyg.png',
  'Triple Burner':
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191690/triple_burner_xvf4zj.png',
  Kidney:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/kidney_s6ufok.png',
  Bladder:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191684/bladder_kxen8s.png',
  Pericardium:
    'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191689/pericardium_mtl12q.png',
};

export const OrganCard = ({ tag, progress, handleOnClick }: OrganCardProps) => {
  return (
    <Card sx={OrganCardStyles.container} onClick={() => handleOnClick(tag)}>
      <Typography sx={OrganCardStyles.organText}>{tag}</Typography>
      <Box sx={OrganCardStyles.imageContainer}>
        <img
          src={TAG_TO_IMAGE[tag]}
          alt={tag}
          style={{ 
            marginBottom: '0px',
            transition: 'transform 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        />
      </Box>
      {progress > 0 && (
        <Box sx={OrganCardStyles.progressContainer}>
          <Box sx={OrganCardStyles.progressRow}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={OrganCardStyles.progressBar}
            />
            <Typography sx={OrganCardStyles.percentageText}>
              {Math.round(progress)}%
            </Typography>
            {progress === 100 && (
              <Typography sx={OrganCardStyles.starEmoji}>⭐</Typography>
            )}
          </Box>
        </Box>
      )}
    </Card>
  );
};

export default OrganCard;
